<template>
  <v-btn-toggle
    v-model="league"
    rounded
    mandatory
    class="league_toggle"
  >
    <v-btn @click="$track('see_ranking', 'ranking', 'gold')">
      {{ $t('RANKING.GOLD') }}
    </v-btn>

    <v-btn @click="$track('see_ranking', 'ranking', 'silver')">
      {{ $t('RANKING.SILVER') }}
    </v-btn>

    <v-btn @click="$track('see_ranking', 'ranking', 'bronze')">
      {{ $t('RANKING.BRONZE') }}
    </v-btn>
  </v-btn-toggle>
</template>

<style scoped lang="scss">
  .league_toggle {
    width: 100%;
    justify-content: center;
  }
  .league_toggle .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    border-color: var(--v-primary-base) !important;
  }

  .league_toggle .v-btn {
    background-color: white !important;
    color: var(--v-primary-base);
    text-transform: none;
    width: 33%;
  }
  .league_toggle .v-btn--active {
    color: white !important;
  }
  .league_toggle .v-btn--active:before {
    opacity: 1 !important;
    background-color: var(--v-primary-base);
  }
</style>

<script>
export default {
  name: 'LeagueToggle',
  props: {
    value: {
      type: [Number, null],
      default: null,
    },
  },
  data: () => ({
    league: null,
  }),
  watch: {
    value: {
      immediate: true,
      handler() {
        this.league = this.value;
      },
    },
    league() {
      this.$emit('input', this.league);
    },
  },
};
</script>
